import { defineBoot } from '@quasar/app-vite/wrappers';
import { Platform } from 'quasar';

// TODO: write tests

/**
 * @param {{ app: import('vue').App }} payload
 */
export default defineBoot(({ app }) => {
  app.directive('capacitor-select-dialog', {
    bind(_, binding, vnode) {
      if (Platform.is.capacitor) {
        vnode.componentInstance.$on('popup-show', binding.def.onDialogOpen);
        vnode.componentInstance.$on('popup-hide', binding.def.onDialogClose);
      }
    },
    unbind(_, binding, vnode) {
      document.body.classList.add('capacitor-select-dialog--open');
      vnode.componentInstance.$off('popup-show', binding.def.onDialogOpen);
      vnode.componentInstance.$off('popup-hide', binding.def.onDialogClose);
    },
    onDialogClose() {
      document.body.classList.remove('capacitor-select-dialog--open');
    },
    onDialogOpen() {
      document.body.classList.add('capacitor-select-dialog--open');
    },
  });
});
